// TrackerBase client sign in component
// use as "tbSignIn" or "tb-sign-in"

import angular from "angular";

import UserAuthModuleConstants from "./ModuleConstants";
import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";
import TbSignInController from "./TbSignInController";

const TbSignInComponent = {
    name: "tbSignIn",
    config: {
        template: TbSignInController.template,
        bindings: {},
        controller: TbSignInController,
        controllerAs: TbSignInController.controllerAs
    }
};

const tbSignInComponentDependencies = DependencyListBuilder([
    TbSignInController.dependencies
]);

export default angular
    .module(`${UserAuthModuleConstants.module_name}.tb-sign-in`, tbSignInComponentDependencies)
    .component(TbSignInComponent.name, TbSignInComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/TbSignIn.js
// module id = j5l9
// module chunks = 1